import {RECIPE_SERVINGS_DATA} from './constants/recipe';
import {initArticleBottomNav} from './modules/article-bottom-nav';
import {initArticleReactions} from './modules/article-reactions';
import {initArticleShareWidget} from './modules/article-share-widget';
import {renderArticleComments} from './modules/comments/comment-article-init';
import {renderCommentsModal} from './modules/comments/comments-modal-init';
import {initEmbeds} from './modules/custom-html';
import initRecommendation from './modules/recommendation';
import {handleTrackingEventContentTypePage} from './services/analytics/content-type';
import {getCommentsCount} from './services/comments';
import {addEventHandlers} from './services/content-type/content-handlers';
import {initInfiniteLoaderContentType} from './services/content-type/init-infinite-loader-content-type';
import {handleOneSignalEmbedAnalyticEvents} from './services/content-type/one-signal-embed-analytics-events';
import initCounter from './services/counter';
import {handleLazyLoadScript} from './services/helpers';

const LIMIT_RECOMMENDED_ARTICLES = 15;

const init = () => {
  const isMobile = window.Site.targeting.platform === 'smartphone';
  const $initialContentType = document.querySelector('.js-article');
  const $infiniteContainer = document.querySelector('.js-infinite');
  const {id} = $initialContentType?.dataset || {};
  const $commentsWrapper = document.querySelector('.js-preview-comments');
  const $articleReactionsWrapper = document.querySelector('.js-article-reactions');
  const $bottomNavContainer = document.querySelector('.js-article-bottom-nav-menu');
  const $articleWidgetContainer = document.querySelector('.js-article-widget');
  const $articleShareWidgetContainer = document.querySelector('.js-article-share');
  const $coverImage = document.querySelector('.js-article-cover-image');
  const isOnboardingForReactionsActive = true;

  renderArticleComments($commentsWrapper, id);
  initArticleReactions($articleReactionsWrapper, id, isOnboardingForReactionsActive);
  initArticleShareWidget($articleShareWidgetContainer, id, isMobile);
  initEmbeds($initialContentType);

  if (isMobile) {
    initArticleBottomNav($bottomNavContainer, id, isMobile, $coverImage);
  } else {
    initArticleBottomNav($articleWidgetContainer, id);
  }

  const $commentModalContainer = document.querySelector('#js-comments-modal');

  renderCommentsModal($commentModalContainer);

  const observeInfiniteArticles = initInfiniteLoaderContentType({
    isMobile,
    $initialContentType,
    $infiniteContainer,
    addEventHandlers,
    getCommentsCount,
    handleOneSignalEmbedAnalyticEvents
  });

  initRecommendation({
    chunkResultList: list => [list, []],
    callback: observeInfiniteArticles,
    limit: LIMIT_RECOMMENDED_ARTICLES
  });

  addEventHandlers($initialContentType, isMobile);
  initCounter({
    ...RECIPE_SERVINGS_DATA,
    $container: $initialContentType.querySelector('.js-counter')
  });
  handleTrackingEventContentTypePage(document.querySelector('.js-content-type-page'));
  handleLazyLoadScript();
  getCommentsCount(id);
};

init();
